import React, { useEffect, useState } from 'react';

import styles from './styles.module.scss';

export const ArchivePlacard = () => (
  <aside className={styles.placard} aria-labelledby="archive-title">
    <div className={styles.catalogLine}>
      <span>Digital collection</span>
      <span>MB-001</span>
    </div>

    <span className={styles.ghostYear} aria-hidden="true">
      2021
    </span>

    <p className={styles.kicker}>Portfolio archive</p>
    <h1 id="archive-title">Snapshot from 2021</h1>
    <p className={styles.copy}>
      A preserved version of my older work. <br />Some details and links may no
      longer be current.
    </p>

    <div className={styles.metaLine}>
      <span>Preserved 2026</span>
      <strong>Archived</strong>
    </div>
  </aside>
);

export const ArchiveMarker = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const updateMarkerPosition = () => setIsScrolled(window.pageYOffset > 100);

    updateMarkerPosition();
    window.addEventListener('scroll', updateMarkerPosition);

    return () => window.removeEventListener('scroll', updateMarkerPosition);
  }, []);

  return (
    <aside
      className={`${styles.marker} ${isScrolled ? styles.markerScrolled : ''}`}
      aria-label="This website is a portfolio archive from 2021"
    >
      <span>Archive</span>
      <strong>2021</strong>
    </aside>
  );
};
